<template>
  <div style="width:100%;height:auto; margin:0 auto;">
    <el-form ref="form" :model="form" label-width="120px">
      <el-divider content-position="left">基础信息</el-divider>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item>
            <div slot="label">名称<font color="red">*</font></div>
            <el-input  :readonly="true"  v-model.trim="form.patName" />
          </el-form-item>
        </el-col>
       
      </el-row>

      <el-form-item>
        <div slot="label">封面图片<font color="red">*</font></div>
        <img :src=form.imageAddress width="50px" height="50px">
      </el-form-item>
    
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item>
            <div slot="label">所属企业<font color="red">*</font></div>
            <el-input  :readonly="true" v-model.trim="form.patCompany" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <div slot="label">服务电话<font color="red">*</font></div>
            <el-input  :readonly="true"  v-model.trim="form.patPhone" @input="phoneInput" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item>
            <div slot="label">管理方式</div>
            <el-checkbox-group :disabled="true" v-model="form.type">
              <el-checkbox v-for="item in patTypeList" :label="item.code"  :key="item.code">{{item.name}}</el-checkbox> 
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      
      </el-row>
      <el-row :gutter="20">
       
       <el-col :span="24">
        <el-form-item>
          <div slot="label">收费标准</div>
          <el-input :readonly="true"  v-model.trim="form.patStandards" type="textarea"/>
        </el-form-item>
      </el-col>
    
    </el-row>
     
      <el-divider content-position="left">区域信息</el-divider>
      <el-row :gutter="20" style="margin-bottom:40px">
        <el-col :span="24">
           <map-container  :visable="visable" :mapLineAll="lineAll" :lng="formlng" :lat="formlat"  @getData="getdata"  :onlyRead="onlyRead"></map-container>
       </el-col>
      </el-row>

    </el-form>
  
  </div>
</template>

<script>
import { downloadById } from '@/api/baseReleaseFile'
import { getDictListByCode } from '@/api/dict'
import { editData } from '@/api/parking'
import MapContainer from "@/components/map2/amap"

import tool from '@/utils/tool'
import { Message } from 'element-ui'

export default {
  name: 'Zzjg',
  inject: ['getList'],
  components: { MapContainer },
  data() {
    return {
      form: {
        type:[]
      },
      formlng:'',
      onlyRead:true,
      formlat:'',
      lineAll:'',
      patTypeList : [],
      code: '',
      types: [],
      visable:true,
      uploadpath:'',
      dialogImageUrl:'',
      downloadPath:'',
      uoloadheaders:{},
      fileList:[] // upload多文件数组
    }
  },
  created() {
    this.getId()
    this.getDictEntry('YW_RELEASE_TYPE')
    this.getDictEntry('parking_gn')
  },
  methods: {
    phoneInput(){
     // 使用正则表达式匹配纯数字
     this.form.patPhone = this.form.patPhone.replace(/\D/g, ''); // 移除非数字
    },
    getDetailed(e){
      this.form= JSON.parse(JSON.stringify(e));
      this.formlng=this.form.lat
      this.formlat=this.form.lng
      this.lineAll=this.form.lineAll
      console.log("formlng:")
    console.log(this.formlng)
    console.log("lineAll:")
    console.log(this.lineAll)
    },
     //获取地图信息
     getdata(e){
      
      if (e.lng!=null) {
        this.form.lng=e.lng
      this.form.lat=e.lat
      this.form.province=e.province
      this.form.city=e.city
      this.form.district=e.district
      this.form.betAddress=e.address
      }
      
      if(e.lineAll!=null){
        this.form.lineAll=e.lineAll
      }
     
      
     
    },
    getDictEntry(code) {
      getDictListByCode(code).then(response => {
        if (code === 'YW_RELEASE_TYPE') {
          this.types = response.data
        }
        if (code === 'parking_gn') {
          this.patTypeList = response.data
        }
        
      })
    },
    getId() {
      this.code = ''
      
     
        
        let address = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL_RECON : process.env.VUE_APP_BASE_API;
        var path1 = 'company-table-file/upload?linkId=' + 1 + '&filetype=bidFile'
        this.uploadpath = address + path1
        this.uoloadheaders = {
          'X-TOKEN' : tool.getCookie('X-Token'),
          'client-url':location.href,
          'applicationId':this.applicationId
        }
      
    },
    beforeAvatarUpload(file) {
      let testFile = file.name
      .substring(file.name.lastIndexOf(".") + 1)
      .toLowerCase();
      const isJPG =
          testFile === "jpeg" ||
          testFile === "jpg" ||
          testFile === "png" ||
          testFile === "PNG" ||
          file.type === "JPG";

          if (!isJPG) {
          this.$message.error("上传图片只能是 JPG或者PNG 格式!");
        
          return false;
          // this.fileUploadList = []
        }
      const isLt2M = file.size / 1024 / 1024 < 100

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过100MB!')
      }
      return isLt2M
    },
    // 选取文件超过数量提示
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    // 文件下载
    handleProgress(file) {
      downloadById({ id: file.fileId }).then(response => {
        var fileName = file.name
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          fileName = window.decodeURI(response.headers['content-disposition'].split('=')[1], 'UTF-8')
        }
        const blob = new Blob([response.data], {
          type: `*`
        })
        const objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    // 监控上传文件列表
    handleChange(file, fileList) {
      const existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name)
      if (existFile) {
        this.$message.error('当前文件已经存在!')
        fileList.pop()
      }
      this.fileList = fileList
    },
    handleAvatarSuccess(res, file) {
      this.uploadLoading = false
      if (res.code === 20000) {
        this.form.imageAddress=file.response.data
        Message({
          message: '上传成功',
          type: 'success',
          duration: 5 * 1000
        })
      } else {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }
    },
    onSave() {
    
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        editData(this.form).then(response => {
          Message({
            message: '修改成功',
            type: 'success',
            duration: 5 * 1000
          })

          loading.close()
          this.$emit('update:visible', false)
          // 重新加载表格
          this.getList()
        }).catch(response => {
          loading.close()
          // 重新加载表格
          this.getList()
        })
      
    },
    closePage() {
      this.$emit('update:visible', false)
      this.getList()
    }
  }
}
</script>
